import React from "react";

/**
 * SiteFooter — global footer present on EVERY page
 * (landing, auth screens, dashboard, testing rooms, mocks, etc.)
 *
 * Per product requirement: "A Product of Cloud Lab Technologies" must be
 * a hyperlink to https://www.cloudlabweb.com opening in a new tab.
 *
 * Two variants:
 *  - "default" (light theme — landing/auth/dashboard pages)
 *  - "dark"    (dark theme — testing rooms / mock simulators)
 */
export default function SiteFooter({ variant = "default", className = "" }) {
  const isDark = variant === "dark";
  const isFixed = variant === "fixed";
  if (isFixed) {
    return (
      <div
        data-testid="site-footer-fixed"
        className={`fixed bottom-0 left-0 right-0 z-30 px-3 py-1 text-[9px] tracking-[0.2em] uppercase text-center pointer-events-none ${className}`}
        style={{
          background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
          color: "rgba(255,255,255,0.65)",
          fontFamily: "'IBM Plex Mono', monospace",
        }}
      >
        <span>A Product of </span>
        <a
          href="https://www.cloudlabweb.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cloud-lab-link-fixed"
          className="font-semibold underline decoration-dotted pointer-events-auto"
          style={{ color: "#F77F00" }}
        >
          Cloud Lab Technologies
        </a>
        <span> ↗</span>
      </div>
    );
  }
  return (
    <footer
      data-testid="site-footer"
      className={`w-full ${className}`}
      style={{
        background: isDark ? "rgba(2, 13, 31, 0.85)" : "#FCFAF3",
        borderTop: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid #E5DCC0",
        color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,48,73,0.65)",
        fontFamily: "'IBM Plex Mono', monospace",
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-[10px] sm:text-[11px] tracking-[0.22em] uppercase">
        <div>
          © 2026 EnglishTest<span style={{ color: "#F77F00" }}>.UK</span> · All Systems Nominal
        </div>
        <div>
          A Product of{" "}
          <a
            href="https://www.cloudlabweb.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cloud-lab-link"
            className="font-semibold underline decoration-dotted transition-colors"
            style={{ color: "#F77F00" }}
          >
            Cloud Lab Technologies
          </a>
          {" "}↗
        </div>
      </div>
    </footer>
  );
}
